<template>
  <voxy-tooltip :theme="theme" class="help-icon">
    <i class="help-icon__icon">
      <font-awesome-icon :icon="['fal', 'question-circle']" />
    </i>
    <template slot="popover">
      <slot></slot>
    </template>
  </voxy-tooltip>
</template>

<script>
import { VoxyTooltip } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import UiThemeMixin from '@/mixins/ui-theme';

export default {
  name: 'HelpIcon',

  mixins: [UiThemeMixin],

  components: { FontAwesomeIcon, VoxyTooltip },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.help-icon {
  cursor: pointer;
  color: $default-grey;

  &:hover {
    color: $default-blue;
  }

  &__icon {
    font-size: 13px;
  }
}
</style>
